<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-7">
                <h5 class="mt-2">Novedades en Ruta</h5>
              </div>
              <div class="col-sm-5">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Hidrocarburos">Hidrocarburos</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operacion</li>
                  <li class="breadcrumb-item active">HSE</li>
                  <li class="breadcrumb-item active">Novedades en Ruta</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="row">
              <!-- Filtros Generales -->
              <div class="card col-md-9">
                <div class="card-header p-1 m-1">
                  <div class="row">
                    <div class="col-md-12">
                      <div class=" btn-group float-right">
                        <button
                          v-if="
                            $store.getters.can(
                              'hidrocarburos.novedadesRuta.exportNovedades'
                            )
                          "
                          type="button"
                          data-toggle="modal"
                          data-target="#modal_form_novedad_export"
                          class="btn btn-success"
                        >
                          <i class="far fa-file-excel"></i>
                        </button>
                        <button
                          type="button"
                          class="btn bg-navy"
                          @click="getNovedades(1)"
                        >
                          <i class="fas fa-search"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="limpiarForm()"
                        >
                          <i class="fas fa-play mr-2"></i>
                          <small>Ver en tiempo real</small>
                        </button>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Viaje</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="# Viaje"
                            v-model="filters.n_viaje"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="">Guía</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="# Guía"
                            v-model="filters.n_guia"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label class="">Vehículo</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Placa"
                            v-model="filters.placa"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="">Nombre Conductor</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Nombre"
                            v-model="filters.n_conductor"
                          />
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="form-group">
                          <label class="">Empresa</label>
                          <v-select
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            v-model="empresa"
                            placeholder="Razon social"
                            label="razon_social"
                            :options="listasForms.empresas"
                            @input="seleccionarEmpresa()"
                          ></v-select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="form-label select-label"
                            >Tipo Novedad</label
                          >
                          <select
                            class="form-control form-control-sm"
                            v-model="filters.tipo_novedad"
                            @change="changeTipo"
                          >
                            <option value="">Seleccione...</option>
                            <option
                              v-for="tipo_novedad in listasForms.tipos_novedades"
                              :key="tipo_novedad.numeracion"
                              :value="tipo_novedad.numeracion"
                            >
                              {{ tipo_novedad.descripcion }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        class="col-md-4"
                        v-if="[1, 2].includes(filters.tipo_novedad)"
                      >
                        <div class="form-group">
                          <label class="form-label select-label"
                            >Sub Novedad</label
                          >
                          <v-select
                            v-if="filters.tipo_novedad == 1"
                            multiple
                            v-model="sub_novedades"
                            label="descripcion"
                            placeholder="Sub Novedades Gps"
                            class="form-control form-control-sm p-0"
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            :options="listasForms.sub_novedades_gps"
                            @input="selectSubNovedades()"
                          >
                          </v-select>

                          <v-select
                            v-if="filters.tipo_novedad == 2"
                            multiple
                            v-model="sub_novedades"
                            label="descripcion"
                            placeholder="Sub Novedades Rutas"
                            class="form-control form-control-sm p-0"
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            :options="listasForms.sub_novedades_rutas"
                            @input="selectSubNovedades()"
                          >
                          </v-select>
                        </div>
                      </div>
                      <div
                        class="col-md-3"
                        v-if="listasForms.relevancias.length"
                      >
                        <div class="form-group">
                          <label class="form-label select-label"
                            >Relevancia</label
                          >
                          <v-select
                            :class="
                              $store.getters.getDarkMode ? 'dark-vselect' : ''
                            "
                            multiple
                            v-model="relevancias"
                            @input="selectRelevancias()"
                            placeholder="Relevancias"
                            label="descripcion"
                            class="form-control form-control-sm p-0"
                            :options="listasForms.relevancias"
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Mapa -->
                <div class="card-body pl-0 pr-0 pt-2 ml-0 mr-0 mt-2">
                  <div
                    class="card-footer p-2"
                    :class="cargando_mapa ? 'overlay-wrapper' : ''"
                  >
                    <div v-if="cargando_mapa" class="overlay">
                      <i class="fas fa-5x fa-sync-alt fa-spin"></i>
                      <div class="text-lg pt-2">Cargando...</div>
                    </div>
                    <!-- Mapa de los últimos seguimientos -->
                    <gmap-map
                      style="width: 100%; height: 500px"
                      id="mapUltimasNovedades"
                      :center="viewMap.center"
                      :zoom="viewMap.zoom"
                      :options="{
                        disableDefaultUI: true,
                        zoomControl: true,
                        mapTypeControl: true,
                      }"
                    >
                      <!-- Iconos de las novedades -->
                      <gmap-marker
                        v-for="(nov, index) in markers.novedad"
                        :key="index"
                        :position="nov.position"
                        :icon="nov.icon"
                        :clickable="true"
                        :info="nov.info"
                        @click="
                          (viewMap.center = nov.position), toggleInfoWindow(nov)
                        "
                      ></gmap-marker>
                      <!-- Popup de informaciones -->
                      <gmap-info-window
                        :options="infoOptions"
                        :position="infoWindowPos"
                        :opened="infoWinOpen"
                        @closeclick="infoWinOpen = false"
                      >
                        <div v-html="infoContent"></div>
                      </gmap-info-window>
                      <!-- Geocercas Poligonos -->
                      <gmap-polygon
                        v-for="poligono in poligonos"
                        :options="{ fillColor: poligono.color }"
                        :key="poligono.id"
                        :paths="poligono.path"
                        :editable="false"
                        :draggable="false"
                        @click="
                          toggleInfoWindowPoli(
                            poligono,
                            poligono.id,
                            poligono.info
                          )
                        "
                      />
                      <!-- Geocercas Circulares -->
                      <gmap-circle
                        v-for="circular in circunferencias"
                        :options="{ fillColor: circular.color }"
                        :key="circular.id"
                        :center="circular.center"
                        :radius="circular.radius"
                        :info="circular.info"
                        @click="toggleInfoWindowCir(circular)"
                      ></gmap-circle>
                    </gmap-map>
                  </div>
                </div>
              </div>
              <!-- Card Ultimos 20 Min -->
              <div class="col-md-3 table-responsive" style="max-height: 800px">
                <div class="timeline">
                  <div class="time-label">
                    <span class="bg-primary text-white"
                      >Ultimos 20 Minutos</span
                    >
                  </div>
                  <div v-for="novedad in novedades" :key="novedad.id">
                    <i
                      :class="
                        novedad.relevancia == 1
                          ? 'fas fa-exclamation-triangle bg-warning'
                          : novedad.relevancia == 2
                          ? 'fas fa-first-aid bg-danger'
                          : 'bg-secondary'
                      "
                      style="cursor: pointer"
                      @click="mapaNovedad(novedad)"
                    ></i>
                    <div class="timeline-item">
                      <span class="time"
                        ><i class="fas fa-clock"></i>
                        {{ novedad.fecha_novedad }}</span
                      >
                      <h3 class="timeline-header">
                        <br />
                      </h3>
                      <div class="timeline-body">
                        <h3 style="font-size: 14px">
                          <b>Tipo Novedad: </b>
                          {{ novedad.nTipoNovedad }}
                        </h3>
                        <h3
                          style="font-size: 14px"
                          v-if="[1, 2].includes(novedad.tipo_novedad)"
                        >
                          <b>Sub Novedad: </b>
                          <span class="badge badge-success">{{
                            novedad.tipo_novedad == 1
                              ? novedad.nSubNovedadGps
                              : novedad.nSubNovedadRuta
                          }}</span>
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Relevancia: </b>
                          <span
                            :class="
                              novedad.relevancia == 1
                                ? 'badge badge-warning'
                                : 'badge badge-danger'
                            "
                            >{{ novedad.nRelevancia }}</span
                          >
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Viaje: </b>
                          <button
                            type="button"
                            class="btn btn-sm btn-default py-0"
                            data-toggle="modal"
                            data-target="#modal-form-detViaje"
                            @click="
                              llenarModalDetViaje(
                                novedad.viaje_id,
                                novedad.viaje.tipo_operacion
                              )
                            "
                          >
                            {{ novedad.viaje_id }}
                          </button>
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Vehículo: </b> {{ novedad.vehiculo.placa }} -
                          {{ novedad.vehiculo.tipo_vehiculo.nombre }}
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Conductor: </b>
                          {{ novedad.conductor.nombres }}
                          {{ novedad.conductor.apellidos }}
                          <em style="font-size: 11px"
                            ><b>CC:</b>
                            {{ novedad.conductor.numero_documento }}</em
                          >
                          <em style="font-size: 11px">
                            <b> CEL:</b>
                            {{ novedad.conductor.celular_principal }}</em
                          >
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Empresa: </b>
                          {{ novedad.viaje.transportadora.razon_social }}
                        </h3>
                        <h3 style="font-size: 14px">
                          <span class="badge bg-navy" style="font-size: 9px"
                            >Latitud: {{ novedad.latitud }}</span
                          >
                          <span
                            class="badge bg-indigo ml-1"
                            style="font-size: 9px"
                            >Longitud: {{ novedad.longitud }}</span
                          >
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Direccion: </b>
                          {{ novedad.direccion }}
                        </h3>
                        <h3 style="font-size: 14px">
                          <b>Velocidad: </b>
                          {{ novedad.velocidad }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div>
                    <i class="fas fa-clock bg-gray"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Tabla Informacion Novedad -->
          <div class="col-md-12">
            <div
              class="card-body p-0 mt-0"
              :class="cargando_mapa ? 'overlay-wrapper' : ''"
            >
              <div v-if="cargando_mapa" class="overlay">
                <i class="fas fa-5x fa-sync-alt fa-spin"></i>
                <div class="text-lg pt-2">Cargando...</div>
              </div>
              <table
                class="
                  table table-bordered table-striped table-hover table-sm
                  text-xs
                "
              >
                <thead class="bg-dark text-center">
                  <tr>
                    <th>
                      Viaje
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.viaje_id"
                        placeholder="#Viaje"
                        @keyup.enter="getNovedades(1)"
                      />
                    </th>
                    <th>
                      Vehículo
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.vehiculo"
                        placeholder="Placa"
                        @keyup.enter="getNovedades(1)"
                      />
                    </th>
                    <th>
                      Conductor
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="filters.conductor"
                        placeholder="Nombre"
                        @keyup.enter="getNovedades(1)"
                      />
                    </th>
                    <th>
                      Tipo Novedad
                      <select
                        class="form-control form-control-sm"
                        v-model="filters.tip_novedad"
                        @keyup.enter="getNovedades(1)"
                      >
                        <option value="">Seleccione...</option>
                        <option
                          v-for="tip_nov in listasForms.tipos_novedades"
                          :key="tip_nov.numeracion"
                          :value="tip_nov.numeracion"
                          >{{ tip_nov.descripcion }}</option
                        >
                      </select>
                    </th>
                    <th>Novedad</th>
                    <th>Latitud</th>
                    <th>Longitud</th>
                    <th>
                      Fecha Novedad
                      <input
                        type="date"
                        v-b-popover.hover.left="'Fecha Expedicion'"
                        class="form-control form-control-sm"
                        v-model="filters.fecha_novedad"
                        placeholder="Expedición Guia"
                        @keyup.enter="getNovedades(1)"
                      />
                    </th>
                    <th>
                      Relevancia
                      <v-select
                        :class="
                          $store.getters.getDarkMode ? 'dark-vselect' : ''
                        "
                        multiple
                        v-model="relevancia"
                        @input="selectRelevancia()"
                        placeholder="Relevancias"
                        label="descripcion"
                        class="form-control form-control-sm p-0"
                        :options="listasForms.relevancias"
                        :filterable="true"
                      ></v-select>
                    </th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr v-for="nov in novedadesPag.data" :key="nov.id">
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-default py-0"
                        data-toggle="modal"
                        data-target="#modal-form-detViaje"
                        @click="
                          llenarModalDetViaje(
                            nov.viaje_id,
                            nov.viaje.tipo_operacion
                          )
                        "
                      >
                        {{ nov.viaje_id }}
                      </button>
                    </td>
                    <td>
                      {{ nov.vehiculo.placa }} -
                      <span class="badge badge-dark">{{
                        nov.vehiculo.tipo_vehiculo.nombre
                      }}</span>
                    </td>
                    <td>
                      {{ nov.conductor.nombres }}
                      {{ nov.conductor.apellidos }} -

                      <span class="badge badge-info">{{
                        nov.conductor.numero_documento
                      }}</span>
                    </td>
                    <td>
                      {{
                        nov.tipo_novedad == 1
                          ? "GPS"
                          : nov.tipo_novedad == 2
                          ? "CALCULO RUTAS"
                          : nov.tipo_novedad == 3
                          ? "INSPECCIONES"
                          : "GEOCERCAS"
                      }}
                    </td>
                    <td>
                      <span class="badge badge-success">{{
                        nov.tipo_novedad == 2
                          ? nov.tipo_subnovedad == 1
                            ? "Fuera de Ruta"
                            : nov.tipo_subnovedad == 2
                            ? "Exceso de Velocidad (Ruta)"
                            : nov.tipo_subnovedad == 3
                            ? "Sin Ruta"
                            : nov.tipo_subnovedad == 4
                            ? "Fuera de Horario"
                            : nov.nSubNovedadRuta || ""
                          : nov.tipo_subnovedad == 5
                          ? "Exceso de velocidad"
                          : nov.tipo_subnovedad == 7
                          ? "Aceleración Brusca"
                          : nov.tipo_subnovedad == 8
                          ? "Frenada Brusca"
                          : nov.tipo_subnovedad == 9
                          ? "Curva Brusca"
                          : nov.tipo_subnovedad == 10
                          ? "Maltrato Suspension"
                          : nov.tipo_subnovedad == 11
                          ? "Alerta Impacto"
                          : nov.tipo_subnovedad == 12
                          ? "Botón Emergencia"
                          : ""
                      }}</span>
                    </td>
                    <td>{{ nov.latitud }}</td>
                    <td>{{ nov.longitud }}</td>
                    <td>{{ nov.fecha_novedad }}</td>
                    <td>
                      <span
                        :class="
                          nov.relevancia == 1
                            ? 'badge badge-warning'
                            : 'badge badge-danger'
                        "
                        >{{ nov.nRelevancia }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer">
              <div class="float-left" v-if="novedadesPag.total">
                <p>
                  Mostrando del <b>{{ novedadesPag.from }}</b> al
                  <b>{{ novedadesPag.to }}</b> de un total:
                  <b>{{ novedadesPag.total }}</b> Registros
                </p>
              </div>
              <div class="float-left" v-else>
                <p>
                  <span class="badge badge-danger"
                    >No hay registros para mostrar</span
                  >
                </p>
              </div>
              <pagination
                :data="novedadesPag"
                @pagination-change-page="getNovedades"
                :limit="10"
                class="float-right m-0"
              >
              </pagination>
            </div>
          </div>
        </section>
        <ViajesDetViaje ref="ViajesDetViaje" />
        <NovedadesExport ref="novedadesExport" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import { VBPopover } from "bootstrap-vue";
import pagination from "laravel-vue-pagination";
import NovedadesExport from "./NovedadesExport";
import ViajesDetViaje from "../viajes/ViajesDetViaje";
import Loading from "../../../../components/Loading";
const google = window.google;

export default {
  name: "NovedadesRutaIndex",
  components: {
    Loading,
    pagination,
    vSelect,
    ViajesDetViaje,
    NovedadesExport,
  },
  directives: {
    "b-popover": VBPopover,
  },
  data() {
    return {
      cargando_mapa: false,
      cargando: false,
      filters: {
        tip_novedad: null,
        tipo_novedad: null,
        n_viaje: null,
        sub_novedades: [],
        relevancias: [],
        relevancia: [],
        n_guia: null,
        viaje_id: null,
        vehiculo: null,
        placa: null,
        conductor: null,
        n_conductor: null,
        fecha_novedad: null,
      },
      flag: false,
      center: {
        lat: 0,
        lng: 0,
      },
      zoom: 6,
      //points: [],
      novedades: [],
      novedadesPag: {},
      page: "",
      relevancias: [],
      relevancia: null,
      sub_novedades: [],
      empresa: null,
      listasForms: {
        empresas: [],
        relevancias: [],
        tipos_novedades: [],
        sub_novedades_gps: [],
        sub_novedades_rutas: [],
      },
      // Datos Mapa
      viewMap: {
        zoom: 6,
        center: {
          lat: 4.651371,
          lng: -74.071509,
        },
        points: [],
        locations: {},
      },
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      markers: {
        novedad: [],
      },
      poligonos: [],
      circunferencias: [],
      infoContent: "",
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      locations: {},
      polling: null,
    };
  },

  methods: {
    llenarModalDetViaje(viaje, tipo_control) {
      this.$refs.ViajesDetViaje.llenar_modal_detViaje(viaje, tipo_control);
    },

    playSound(sound) {
      var audio = new Audio(require("@/assets/" + sound));
      audio.play();
    },

    getCenterMap(novedad = null) {
      if (novedad) {
        return {
          lat: parseFloat(novedad.latitud),
          lng: parseFloat(novedad.longitud),
        };
      } else {
        return {
          lat: parseFloat(4.651371),
          lng: parseFloat(-74.071509),
        };
      }
    },

    mapaNovedad(novedad) {
      this.infoWinOpen = false;
      this.showGeocercas();
      if (novedad) {
        this.flag = true;
        this.center = {
          lat: parseFloat(novedad.latitud),
          lng: parseFloat(novedad.longitud),
        };

        // Datos del origen
        let ntipoSubnovedad =
          novedad.tipo_novedad == 2
            ? novedad.tipo_subnovedad == 1
              ? "Fuera de Ruta"
              : novedad.tipo_subnovedad == 2
              ? "Exceso de Velocidad (Ruta)"
              : novedad.tipo_subnovedad == 3
              ? "Sin Ruta"
              : novedad.tipo_subnovedad == 4
              ? "Fuera de Horario"
              : novedad.nSubNovedadRuta || ""
            : novedad.tipo_subnovedad == 5
            ? "Exceso de velocidad"
            : novedad.tipo_subnovedad == 7
            ? "Aceleración Brusca"
            : novedad.tipo_subnovedad == 8
            ? "Frenada Brusca"
            : novedad.tipo_subnovedad == 9
            ? "Curva Brusca"
            : novedad.tipo_subnovedad == 10
            ? "Maltrato Suspension"
            : novedad.tipo_subnovedad == 11
            ? "Alerta Impacto"
            : novedad.tipo_subnovedad == 12
            ? "Botón Emergencia"
            : "";

        let ntipoNovedad =
          novedad.tipo_novedad == 1
            ? "GPS"
            : novedad.tipo_novedad == 2
            ? "CALCULO RUTAS"
            : novedad.tipo_novedad == 3
            ? "INSPECCIONES"
            : "GEOCERCAS";

        this.viewMap = {
          center: this.center,
          icon: "/img/icon_punto_g_ok.png",
          info:
            "<div class='wrapper'><h3 style='font-size:15px' class='text-center'>Vehículo: " +
            novedad.vehiculo.placa +
            "</h3><hr><b>Fecha Novedad: </b> " +
            novedad.fecha_novedad +
            "<br><b>Empresa: </b> " +
            novedad.viaje.transportadora.razon_social +
            "<br><b>Conductor: </b> " +
            novedad.conductor.nombres +
            " " +
            novedad.conductor.apellidos +
            "<br><b>Tipo Novedad: </b> " +
            "<span class='badge badge-info'>" +
            ntipoNovedad +
            "</span>" +
            "<br><b>Novedad: </b> " +
            "<span class='badge badge-success'>" +
            ntipoSubnovedad +
            "</span>" +
            "<br><b>Relevancia: </b> " +
            novedad.nRelevancia +
            "<br> <b>Velocidad: </b> " +
            novedad.velocidad +
            " Km/h" +
            "<br> <b>Direccion:</b> " +
            novedad.direccion +
            "<br> <b>Viaje:</b> " +
            novedad.viaje_id +
            "<br> <b>Longitud:</b> " +
            novedad.longitud +
            "<br> <b>Latitud:</b> " +
            novedad.latitud +
            "</div>",
          id: novedad.id,
          zoom: 10,
        };
        this.zoom = 10;
        this.$swal({
          icon: "success",
          title: "En el mapa se muestra la ubicacion de la novedad",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    },

    async getNovedades(page) {
      this.page = page;
      this.cargando_mapa = true;
      let me = this;
      await axios
        .get("/api/hidrocarburos/getNovedades?page=" + page, {
          params: this.filters,
        })
        .then(async (response) => {
          let novedades = [];
          novedades = response.data;
          me.novedades = novedades.novedades;
          me.novedadesPag = novedades.novedadesPag;
          await me.getMarkersNovedad();
          me.renderNovedades();
          this.cargando_mapa = false;
        });
    },

    renderNovedades() {
      let horaAnt = moment()
        .subtract(21, "seconds")
        .format("YYYY-MM-DD HH:mm:ss");

      for (let i = 0; i < this.novedades.length; i++) {
        let horaAct = new Date(this.novedades[i].created_at);
        horaAct = moment(horaAct).format("YYYY-MM-DD HH:mm:ss");
        if (horaAct >= horaAnt) {
          let sound = null;
          if (this.novedades[i].relevancia == 1) {
            sound = "advertencia.mp3";
          } else {
            sound = "emergencia.mp3";
          }
          this.playSound(sound);
        }
      }
    },

    selectSubNovedades() {
      this.filters.sub_novedades = this.sub_novedades.map((e) => e.id);
    },

    selectRelevancias() {
      this.filters.relevancias = this.relevancias.map((e) => e.numeracion);
    },

    selectRelevancia() {
      this.filters.relevancia = this.relevancia.map((e) => e.numeracion);
    },

    seleccionarEmpresa() {
      this.filters.empresa_id = this.empresa ? this.empresa.id : null;
    },

    getTipoNovedades() {
      axios.get("/api/lista/157").then((response) => {
        this.listasForms.tipos_novedades = response.data;
      });
    },

    getRelevancias() {
      axios.get("/api/lista/149").then((response) => {
        this.listasForms.relevancias = response.data;
      });
    },

    getSubNovedadesGps() {
      axios.get("/api/lista/158").then((response) => {
        this.listasForms.sub_novedades_gps = response.data;
      });
    },

    getSubNovedadesRutas() {
      axios.get("/api/lista/159").then((response) => {
        this.listasForms.sub_novedades_rutas = response.data;
      });
    },

    buscarEmpresas() {
      let me = this;
      const url = "api/admin/empresas/lista?estado=1";
      axios
        .get(url)
        .then(function(response) {
          me.listasForms.empresas = response.data;
        })
        .catch(function(error) {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    changeTipo() {
      this.filters.sub_novedades = [];
      this.sub_novedades_gps = [];
      this.sub_novedades_rutas = [];
    },

    async centerNovedad(novedad) {
      this.lat = parseFloat(novedad.latitud);
      this.lng = parseFloat(novedad.longitud);
      this.zoom = 15;
    },

    pollData() {
      this.polling = setInterval(() => {
        this.getNovedades(this.page);
      }, 20000);
    },

    toggleInfoWindow: function(data) {
      this.infoWindowPos = data.position;
      this.infoContent = data.info;

      //compruebe si es el mismo marcador que se seleccionó en caso afirmativo alternar
      if (this.currentMidx == data.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si es un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = data.id;
      }
    },

    toggleInfoWindowPoli: function(poli) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = poli.info;

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == poli.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = poli.id;
      }
    },

    toggleInfoWindowCir: function(cir) {
      this.infoWindowPos = cir.center;
      this.infoContent = cir.info;

      //compruebe si es el mismo marcador que se seleccionó y en caso afirmativo alternar
      if (this.currentMidx == cir.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //si un marcador diferente establece la ventana de información para abrir y restablecer el índice de marcador actual
      else {
        this.infoWinOpen = true;
        this.currentMidx = cir.id;
      }
    },

    async showGeocercas() {
      this.cargando = true;
      await axios
        .get("/api/hidrocarburos/mapas/showGeocercas")
        .then((response) => {
          this.cargando = false;
          this.locations = response.data.gps_fin;
          this.locations.geocerca_poli.forEach((geocerca) => {
            if (geocerca.puntos.length > 0) {
              let puntos = [];
              geocerca.puntos.forEach((punto) => {
                puntos.push({
                  lng: parseFloat(punto.longitud),
                  lat: parseFloat(punto.latitud),
                });
              });

              this.poligonos.push({
                id: geocerca.id,
                name: geocerca.desc,
                path: puntos,
                info: geocerca.ventana,
                color: geocerca.color,
              });
            }
          });
          for (var j = 0; j < this.locations.geocerca_cir.length; j++) {
            if (this.locations.geocerca_cir[j]["lat"] !== "") {
              this.circunferencias.push({
                center: {
                  lat: parseFloat(this.locations.geocerca_cir[j]["lat"]),
                  lng: parseFloat(this.locations.geocerca_cir[j]["lon"]),
                },
                radius: parseFloat(this.locations.geocerca_cir[j]["radio"]),
                info: this.locations.geocerca_cir[j]["ventana"],
              });
            }
          }
        })
        .catch(function(error) {
          this.cargando = false;
        });
    },

    getMarkersNovedad() {
      this.novedades.forEach((nov) => {
        const tipo_novedad =
          nov.tipo_novedad == 1
            ? nov.nTipoSubNovedadGPS
            : nov.tipo_novedad == 2
            ? nov.nTipoSubNovedadRuta
            : null;

        const intHeading =
          nov.vehiculo.ultimo_registro_g_p_s &&
          nov.vehiculo.ultimo_registro_g_p_s.gps
            ? nov.vehiculo.ultimo_registro_g_p_s.gps.intHeading
            : "";
        const path = `
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="30">
                  <circle cx="13" cy="13.5" r="13" stroke="white" stroke-width="2" fill="${
                    nov.relevancia == 1 ? "#FFC300" : "#d1270f"
                  } "></circle>
                  <path
                    fill="${nov.relevancia == 1 ? "#d1270f" : "#ff8f00"}"
                    stroke="white"
                    stroke-width="1"
                    d="M 7 7 L 13 11 L 19 7 L 13 21 Z"
                    transform="rotate(${
                      intHeading
                        ? parseFloat(intHeading.replace(",", ".")) - 180
                        : -180
                    }, 13, 13)">
                  </path>
                  <rect width="39" height="15" fill="black" stroke="black" x="26" y="6"></rect>
                  <text font-size="10" font-family="" x="28" y="16" fill="white">
                    ${nov.vehiculo.placa}
                  </text>
                </svg>
        `;
        const encodedPath = encodeURIComponent(path);
        const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

        let svgMarker = {
          url: iconUrl,
          fillColor: "#b0c442",
          fillOpacity: 1,
          strokeColor: "#00529c",
          strokeWeight: 1,
          strokeOpacity: 0.7,
          rotation: intHeading
            ? parseFloat(intHeading.replace(",", ".")) - 180
            : -180,
          scale: 0.7,
          anchor: new google.maps.Point(15, 30),
        };

        this.markers.novedad.push({
          id: nov.id,
          position: {
            lat: parseFloat(nov.latitud.replace(",", ".")),
            lng: parseFloat(nov.longitud.replace(",", ".")),
          },
          icon: svgMarker,
          info: `
              <h3 class="text-sm mb-0 ${
                nov.relevancia == 1 ? "text-warning" : "text-danger"
              }">${nov.nTipoNovedad} <small>${
            tipo_novedad ? `(${tipo_novedad})` : ""
          }</small></h3>
              <p class="mb-2"><small>${nov.fecha_novedad}</small></p>
              <p class="mb-0"><strong>${
                nov.vehiculo ? nov.vehiculo.placa : ""
              }</strong><small class="float-right">${
            nov.velocidad
          }Km/h</small></p>
              <p class="mb-0">${
                nov.conductor
                  ? `${nov.conductor.nombres} ${nov.conductor.apellidos}`
                  : ""
              }</p>
              <p class="mb-1"><small>${nov.direccion}</small></p>
            `,
        });
      });
    },

    limpiarForm() {
      this.filters = {
        tipo_novedad: null,
        sub_novedades: [],
        relevancias: [],
        relevancia: [],
        n_viaje: null,
        viaje_id: null,
        n_guia: null,
        vehiculo: null,
        conductor: null,
        fecha_novedad: null,
      };
      this.getNovedades();
    },
  },

  beforeDestroy() {
    clearInterval(this.polling);
  },

  created() {
    this.pollData();
  },

  mounted() {
    this.getNovedades(1);
    this.getRelevancias();
    this.buscarEmpresas();
    this.getTipoNovedades();
    this.getSubNovedadesGps();
    this.getSubNovedadesRutas();
  },
};
</script>
